<template>
  <div
    class="google-btn flex items-center w-full"
    :class="rounded ? 'rounded' : ''"
    :style="minWidth ? `min-width: ${minWidth}` : ''"
    @click="$emit('click')">
    <div class="google-icon-wrapper">
      <img
        class="google-icon"
        alt="Google"
        src="../../../assets/img/google/google-g-logo.svg"/>
    </div>
    <p class="btn-text mx-auto">
      <slot>
        {{ text }}
      </slot>
    </p>
  </div>
</template>

<script>
/**
 * Sign in google button
 *
 * @module views/pages/auth/components/SignInGoogleButton
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'GoogleButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    minWidth: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:500);

.google-btn {
  width: 184px;
  height: 42px;
  background-color: #4285f4;
  border-radius: 6px;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);

  &.rounded {
    border-radius: 50px !important;
    height: 48px !important;

    .google-icon-wrapper {
      margin-left: 5px;
      border-radius: 50px;
    }
  }

  .google-icon-wrapper {
    position: absolute;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background-color: #fff;
  }

  .google-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 18px;
    height: 18px;
  }

  .btn-text {
    color: #fff;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto", serif;
  }

  &:hover {
    box-shadow: 0 0 6px #4285f4;
    cursor: pointer;
  }

  &:active {
    background: #1669F2;
  }
}
</style>
